import type { Cell } from "./xlsx";

// A spreadsheet runs a CSV cell that starts like a formula; prefix it so it stays text.
const FORMULA_START = /^[=+\-@\t\r]/;

const csvField = (value: Cell): string => {
  if (value === null || value === undefined) return "";
  if (typeof value === "number" || typeof value === "boolean") return String(value);
  let text = String(value);
  if (FORMULA_START.test(text) && Number.isNaN(Number(text))) text = `'${text}`;

  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

// BOM so Excel opens UTF-8 (accents, names) correctly.
export const buildCsv = (header: string[], rows: Cell[][]): Blob =>
  new Blob(["﻿", [header, ...rows].map((row) => row.map(csvField).join(",")).join("\r\n")], {
    type: "text/csv;charset=utf-8",
  });

export const downloadBlob = (blob: Blob, fileName: string): void => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
